import { Skeleton } from '@/_components/ui/skeleton'
import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { ContentContainer } from '@/features/_components/content-container'
import { Container } from '@/features/_components/ui/container'
import { useApplicationParams } from '@/features/_hooks/use-application-params'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { PersonHeader } from '../_components/person-header'
import { PersonHeaderSkeleton } from '../_components/person-header.skeleton'
import { ApplicationInfoContent } from './_components/application-info-content'

const ApplicationInfoPage = ({ session }: WithAuthComponentProps) => {
  const { companyId, facilityId, applicationId } = useApplicationParams()

  const { data, isLoading } = useQuery({
    ...queries.applications.detailFull(companyId, facilityId, applicationId),
    enabled: !!companyId && !!facilityId,
  })

  if (isLoading || !data)
    return (
      <Container className="h-full px-14 py-10 gap-6">
        <PersonHeaderSkeleton />
        <div className="scrollbar w-full overflow-y-auto">
          <ContentContainer className="gap-4">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-64" />
            <Skeleton className="h-40 w-full" />
          </ContentContainer>
        </div>
      </Container>
    )

  const { application, facility } = data

  return (
    <Container className="h-full overflow-hidden px-14 py-10 gap-6">
      <PersonHeader
        application={application}
        person={application.person}
        facility={facility}
        userType={session.user.userType}
      />
      <div className="scrollbar min-h-0 w-full flex-1 overflow-y-auto">
        <ApplicationInfoContent application={application} />
      </div>
    </Container>
  )
}

export default WithAuth(ApplicationInfoPage, { allowedFor: ['staff', 'tenant'] })
